import { Injectable } from '@angular/core';
import { UrlTree, Router } from '@angular/router';
import { NbAuthService } from '@nebular/auth';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { SharedServiceService } from '../shared-service.service';

@Injectable({
  providedIn: 'root'
})
export class ToLoginGuard  {

  unixTimestamp: number = 0;

  constructor(private authService: NbAuthService,
    private router: Router,
    private _sharedService: SharedServiceService) { }

  canActivate(): Observable<boolean | UrlTree> {
    return this.authService.getToken().pipe(
      map(token => {
        if (token.getPayload() != null) {
          if (token.isValid()) {
            setTimeout(() => {
              this.unixTimestamp = token.getPayload().exp;
              this._sharedService.emitChange({
                dateExp: this.unixTimestamp
              });
            }, 2000)
            return true;
          }
          return this.router.parseUrl('/auth/logout');
        } else {
          return this.router.parseUrl('/auth/loginDav');
        }
      })
    );
  }
}
